import {
    Checkbox,
    createStyles,
    FormControl,
    FormControlLabel,
    FormGroup,
    Grid,
    Theme,
    WithStyles,
    withStyles
} from '@material-ui/core'
import * as R from 'ramda'
import * as React from 'react'


import {SupportiveService, SupportiveServiceItems} from '../../../../services/Model/Outcome'
import {Nullable} from "../../../../services/utils";

interface SSCheckboxGroupProps extends WithStyles<typeof styles> {
    services: Nullable<SupportiveService[]>,
    required?: boolean
    onServiceCheck: (serviceName: SupportiveService[]) => void
}

const SupportedServicesCheckboxGroup: React.FC<SSCheckboxGroupProps> = (props: SSCheckboxGroupProps) => {
    const { classes, onServiceCheck, services, required } = props;

    const [localServices, setServices] = React.useState<any>(services || []);

    React.useEffect(() => {
        setServices(services)
    });

    const handleCheckboxSelect = (checkboxValue: string) => {
        const localArray = [...localServices!]

        if(R.contains(checkboxValue, localArray))  {
            const filtered = R.filter((x) => !R.equals(x, SupportiveService[checkboxValue]), localArray);

            onServiceCheck(filtered);
        } else {
            onServiceCheck(R.append(SupportiveService[checkboxValue], localArray))
        }
    }

    const isChecked = (value: string) : boolean => {
      if(!localServices || localServices.length === 0) {
        return false
      }
      return R.contains(value, [...localServices!])
    }

    return (
        <FormControl className={classes.root}>
            <Grid container={true} spacing={8} style={{ margin: '0px' }}>
                <Grid item={true} xs={12} md={3} className={classes.label}>
                    Supportive Services Provided&#58;
                </Grid>
                <Grid item={true} xs={12} md={9} style={{'padding': '0'}}>
                    <FormGroup row={true}>
                        <Grid container={true} spacing={8} style={{ margin: '0px' }}>
                            {
                                SupportiveServiceItems.map((serviceItem) => {
                                    return (
                                        <Grid item={true} xs={12} md={9}
                                              style={{'padding': '0'}}
                                              key={serviceItem.value}>
                                            <FormControlLabel
                                                label={serviceItem.label}
                                                control={
                                                    <Checkbox
                                                        checked={isChecked(serviceItem.value)}
                                                        onChange={() => handleCheckboxSelect(serviceItem.value)}
                                                        name={serviceItem.label}
                                                        color="primary"
                                                        inputProps={{ 'aria-label': `${serviceItem.label}-checkbox` }}
                                                        required={
                                                            required &&
                                                            (!localServices || R.isEmpty(localServices))
                                                        }
                                                    />
                                                }
                                            />
                                        </Grid>
                                    )
                                })
                            }
                        </Grid>
                    </FormGroup>
                </Grid>
            </Grid>
        </FormControl>
    )
}

const styles = (theme: Theme) =>
    createStyles({
        root: {
        },
		label: {
			justifyContent: 'flex-end',
			display: 'flex',
			paddingRight: '8px',
			alignItems: 'center',

			[theme.breakpoints.down('sm')]: {
				flexBasis: '100%',
				justifyContent: 'flex-start',
			},
		},
    })

export default withStyles(styles)(SupportedServicesCheckboxGroup)
